import { createHashedStore } from 'totalinvoice-frontend-core'

const storageKey = "user"

const defaultValues = {
    users: []
}

// TODO only create store if user is logged in
const store = createHashedStore(storageKey, defaultValues)

function emptyUser() {
    return {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        emailVerified: false,
        createdTimestamp: "",
        enabled: false,
    }
}

export { store as userStore, emptyUser }
